import React from 'react';
import { Navigate } from 'react-router-dom';

/** Legacy URL: role management now lives on /admin/users. */
export default function AdminSettingsPage() {
  return <Navigate to="/admin/users" replace />;
}
